// DASHBOARD CARD SECTION WITH COUNTS

import React from 'react'
import './DashboardCard.css'

function DashboardCard({ color1 = "#9575CD", color2 = '#A67DFF', title, count, icon, subTitle }) {
    return (

        <div className='dc-container' style={{ background: `linear-gradient(to right, ${color1}, ${color2})` }}>
            <div className='dc-layout'>
                <div className='dc-top-section'>
                    <span className='dashboard-icon-style'>{icon}</span>
                    <span className='dc-title-2'>{count}</span>
                </div>
                <div>
                    <span className='dc-title-1'>{title}</span><span className='dc-sub-title-2'>{subTitle}</span>
                </div>
            </div>
        </div>


        // <div className='dc-container' style={{ background: `${color}` }}>
        //     <div className='dc-layout'>
        //         <div className='dc-top-section'>
        //             <span className='dc-title-1'>Total Sites</span>
        //             <img src={image} alt="Icon" />
        //         </div>
        //         <div>
        //             <div>
        //                 <span className='dc-title-2'>{count}</span>
        //             </div>
        //             <div className='dc-footer-section' >
        //                 <div>18 Active  </div>  <div className='dc-footer-sub-section'>  <GoDotFill /> 4 Delayed  </div>  <div className='dc-footer-sub-section'><GoDotFill /> Completed  </div>
        //             </div>
        //         </div>
        //     </div>
        // </div>



    )
}

export default DashboardCard